<template>
  <Hierarchy
    v-if="!isLoading"
    ref="hierarchy"
    :initialState="initialState"
    :type="type"
    :sites="sites"
    :siteId="siteId"
    :query="query"
    :filterSitesFn="filterSitesFn"
    :showSiteCheckboxes="showSiteCheckboxes"
    :checkDescendants="checkDescendants"
    @change="$emit('change')"
    @isNavigating="emit('isLoaded')"
  />
</template>

<script setup>
import { computed, ref, watchEffect } from "vue";
import { useSites } from "@/Composables/useSites";
import { LinkedToStep, Hierarchy } from "@/Components/LinkedTo";

const emit = defineEmits(["apply", "change", "isLoaded"]);

const props = defineProps({
  initialState: { type: Object, default: null },
  type: {
    type: String,
    validator: (val) => ["single", "multiple"].includes(val),
    default: "multiple",
  },
  siteId: { type: String, required: false },
  query: { type: String, default: "" },
  filterSitesFn: { type: Function, default: null },
  showSiteCheckboxes: { type: Boolean, default: true },
  checkDescendants: { type: Boolean, default: true },
});

const hierarchy = ref(null);
const { isLoading, data: sites } = useSites();

watchEffect(() => {
  if (!isLoading.value) {
    emit("isLoaded");
  }
});

const showBack = computed(() =>
  !props.siteId
    ? hierarchy.value?.currentStep !== LinkedToStep.SITES
    : hierarchy.value?.currentStep !== LinkedToStep.TYPES
);

const showApply = computed(
  () => hierarchy.value?.currentStep !== LinkedToStep.SEARCH
);

const showSearch = computed(
  () => hierarchy.value?.currentStep !== LinkedToStep.SITES
);

const disableApply = computed(() => !hierarchy.value?.hasSelectionBeenMade);

function handleBack() {
  hierarchy.value?.handleBack();
}

function handleApply() {
  emit("apply", hierarchy.value?.getState());
}

function getChecked() {
  return hierarchy.value?.getChecked();
}

defineExpose({
  showBack,
  showApply,
  showSearch,
  disableApply,
  handleBack,
  handleApply,
  getChecked,
});
</script>
